var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"app-loading",attrs:{"column":"","align-center":"","justify-center":"","fill-height":""}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('base-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }